import { render, staticRenderFns } from "./DiffusionExpressResults.vue?vue&type=template&id=61a18d12&"
import script from "./DiffusionExpressResults.vue?vue&type=script&lang=ts&"
export * from "./DiffusionExpressResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports